import { useEffect, useState } from "react";
import { Download, Share, SquarePlus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const KEY = "iosegnalo-install-dismissed";
const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

const IosSteps = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="w-[calc(100%-2rem)] max-w-sm rounded-2xl" data-testid="install-ios-dialog">
      <DialogHeader><DialogTitle>Installa iosegnalo.net</DialogTitle><DialogDescription>Aggiungi l'icona alla schermata Home in 3 passi.</DialogDescription></DialogHeader>
      <ol className="space-y-4 text-sm text-[#495850]">
        <li className="flex items-center gap-3"><Share className="h-5 w-5 shrink-0 text-[#0F2D5E]" /><span>1. In Safari tocca il tasto <strong>Condividi</strong> in basso.</span></li>
        <li className="flex items-center gap-3"><SquarePlus className="h-5 w-5 shrink-0 text-[#0F2D5E]" /><span>2. Scegli <strong>Aggiungi alla schermata Home</strong>.</span></li>
        <li className="flex items-center gap-3"><Download className="h-5 w-5 shrink-0 text-[#0F2D5E]" /><span>3. Tocca <strong>Aggiungi</strong>: l'icona apparirà sul telefono.</span></li>
      </ol>
    </DialogContent>
  </Dialog>
);

export const InstallApp = () => {
  const [prompt, setPrompt] = useState(null);
  const [show, setShow] = useState(false);
  const [iosOpen, setIosOpen] = useState(false);

  useEffect(() => {
    if (isStandalone() || localStorage.getItem(KEY)) return;
    if (isIos()) setShow(true);
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); setShow(true); };
    const onInstalled = () => setShow(false);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("beforeinstallprompt", onPrompt); window.removeEventListener("appinstalled", onInstalled); };
  }, []);

  const install = async () => {
    if (!prompt) return setIosOpen(true);
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === "accepted") setShow(false);
    setPrompt(null);
  };
  const dismiss = () => { localStorage.setItem(KEY, "1"); setShow(false); };

  if (!show) return <IosSteps open={iosOpen} onOpenChange={setIosOpen} />;
  return (
    <>
      <div className="rise fixed inset-x-3 bottom-3 z-50 flex items-center gap-3 rounded-2xl bg-[#0F2D5E] p-3 text-white shadow-2xl md:inset-x-auto md:right-6 md:bottom-6 md:w-96" data-testid="install-app-banner">
        <img src="/app/icon-192.png" alt="" className="h-11 w-11 shrink-0 rounded-xl" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-bold">Installa l'app</p>
          <p className="text-xs text-white/75">Aggiungi iosegnalo.net alla schermata Home</p>
        </div>
        <Button onClick={install} className="h-10 shrink-0 rounded-full bg-[#F4C20D] px-4 font-bold text-[#0F2D5E] hover:bg-[#F4C20D]/90" data-testid="install-app-btn">Installa</Button>
        <button onClick={dismiss} aria-label="Chiudi" className="grid h-9 w-9 shrink-0 place-items-center rounded-full text-white/70 hover:bg-white/10" data-testid="install-app-dismiss"><X className="h-4 w-4" /></button>
      </div>
      <IosSteps open={iosOpen} onOpenChange={setIosOpen} />
    </>
  );
};
